/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import { InputGroup, Form, Col } from 'react-bootstrap';
import cln from 'classnames';
import _noop from 'lodash/noop';
import ErrorMessage from '../ErrorMessage';
import './styles.scss';
import styles from '../../../newComponents/CreateEvent/TermsPDF/styles.module.sass'

export default function CheckBox({
  label = '',
  hasValidation = true,
  className = '',
  containerClassName = '',
  groupClassName = '',
  labelClassName = '',
  onBlur,
  onChange,
  type = 'checkbox',
  value,
  showCheck = true,
  removable = false,
  selectedInitial = false,
  onLabelClick = _noop,
  ...props
}) {
  const { values } = useFormikContext();
  const [field, meta, helpers] = useField(props);
  const { error, touched } = meta;

  const inputRef = useRef();

  const isRadio = type === 'radio';
  const isRadioChecked = values[field.name] === value;

  const handleChange = () => {
    const checkboxValue = !field.value;

    const newValue = isRadio ? value : checkboxValue;

    helpers.setValue(newValue);

    if (onChange) onChange({ target: { value: newValue } });
  };

  const handleClick = () => {
    if (isRadio && removable && isRadioChecked) {
      helpers.setValue(meta.initialValue);

      if (onChange) onChange({ target: { value: meta.initialValue } });
    }
  };

  useEffect(()=>{
    if(selectedInitial){
      inputRef.current?.click();
    }
  },[selectedInitial])

  const handleClickLabel = () => {
    inputRef.current?.click();
    onLabelClick();
  };

  return (
        <div className={showCheck ? null : styles?.hiddenAcept}>
          <InputGroup
            hasValidation={hasValidation}
            className={`Input my-2 ${groupClassName}`}
          >
            <Col xs={12} className={containerClassName}>
              <Form.Check {...field} id={field.name} className={className}>
                <Form.Check.Input
                  {...field}
                  type={type}
                  isValid
                  isInvalid={touched && error}
                  value={value || field.value}
                  onChange={handleChange}
                  checked={isRadio ? isRadioChecked : field.value}
                  onClick={handleClick}
                  ref={inputRef}
                />
                <label
                  onClick={handleClickLabel}
                  aria-hidden
                  className={cln('ml-2 mt-1', labelClassName)}
                >
                  {label}
                </label>
              </Form.Check>
            </Col>

            <ErrorMessage {...meta} className="text-left" />
          </InputGroup>
        </div>
  );
}

CheckBox.propTypes = {
  label: PropTypes.string,
  hasValidation: PropTypes.bool,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  groupClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  type: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  removable: PropTypes.bool,
  onLabelClick: PropTypes.func
};
